<template>
  <transition name="modal">
    <div class="modal-overlay" style="opacity: 1.09; display: block">
      <div
        class="modal-wrapper showSweetAlert visible"
        data-has-cancel-button="true"
        data-has-confirm-button="true"
        data-allow-outside-click="false"
        data-has-done-function="true"
        data-animation="pop"
        data-timer="null"
        style="display: block; top: 130px"
      >
        <div class="modal-close col-sm-12 text-right">
          <button class="modal-button" @click="closeModal()">
            <span class="icon-close"></span>
          </button>
        </div>
        <header class="modal-header">
          <h2 class="modal-title">
            Search for existing user with accounts to merge
          </h2>
        </header>
         <div class="modal-body mt-lg">
           <form role="form" class="mb-xl top-margin form-row" novalidate>
             <div class="form-group has-feedback searchbox">
               <input
                 autofocus
                 v-model="searchText"
                 id="search"
                 type="text"
                 placeholder="Search by first name, last name, or user email"
                 autocomplete="off"
                 class="form-control"
               />
               <button
                 type="submit"
                 class="btn btn-default btn-lg"
                 :disabled="isSearchDisabled || isSearching"
                 @click.prevent="searchUsers()"
               >
                 <span v-if="!isSearching">
                   <em class="icon-magnifier pr-sm"></em> Search
                 </span>
                 <span v-else>
                   <em class="fa fa-spinner fa-spin pr-sm"></em> Searching...
                 </span>
               </button>
             </div>
           </form>
          <div v-if="users.length === 0 && hasSearched && !isSearching" class="panel-body">
            <div
              class="alert alert-info alert-dismissible mt-lg not-found-alert"
              role="alert"
            >
              <p>
                <em class="icon-info pr-sm"></em>No users with accounts found.
             </p>
            </div>
          </div>
           <div v-if="users.length > 0" class="table-responsive top-margin">
            <table class="table table-striped bank-accounts table-fundings">
              <thead>
                <tr>
                  <th>First name</th>
                  <th>Last name</th>
                  <th>Email</th>
                  <th>User type</th>
                  <th>Account(s)</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in users" :key="user.id">
                  <td>{{ user.firstName }}</td>
                  <td>{{ user.lastName }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ getUserTypeLabel(user.userType) }}</td>
                  <td>{{ user.accounts.length }}</td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-warning btn-outline"
                      @click="confirmMergeUser(user)"
                    >
                      Merge with this user
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-buttons mt-lg">
          <div class="row">
            <div class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-info btn-lg btn-done"
                @click="closeModal()"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
 import { mapActions } from 'vuex';

 import { Events } from '@/data/static/events';
 import { getUserTypeLabel } from '@/util';
 import { SearchTypes } from '@/data/static/searchTypes';

 const mix = {
   methods: {
     getUserTypeLabel,
   },
 };

export default {
   name: 'MergePartialUser',
   data() {
     return {
       searchText: '',
       users: [],
       hasSearched: false,
       isSearching: false,
       searchTypes: SearchTypes,
     };
   },
   mixins: [mix],
   props: {
     closeAction: {
       type: Function,
       required: true,
     },
     partialUserId: {
       type: Number,
       required: true,
     },
   },
   computed: {
     isSearchDisabled() {
       return !this.searchText.length > 0;
     },
   },
   methods: {
     closeModal() {
       this.closeAction();
     },
     async searchUsers() {
       try {
         if (!this.searchText.length) {
           this.users = [];
           return;
         }
         this.isSearching = true;
         const response = await this.getAccounts({
           searchString: this.searchText,
           searchBy: this.searchTypes.NAME_EMAIL.name,
         });
         this.hasSearched = true;
         if (response.statusCode === 401) {
           this.users = [];
         } else {
           // Filter to only show users with accounts (accounts.length > 0)
           // and exclude the current partial user
           this.users = (response.users || []).filter(
             user =>
               user.accounts &&
               user.accounts.length > 0 &&
               user.id !== this.partialUserId,
           );
         }
       } catch (error) {
         this.setErrorsModalInfo(['We could not retrieve users list']);
         this.showErrorsModal();
       } finally {
         this.isSearching = false;
       }
     },
     ...mapActions('account', ['getAccounts']),
     confirmMergeUser(user) {
       this.$emit(Events.USER_MERGE_REQUESTED, { targetUserId: user.id });
     },
   },
 };
</script>

<style scoped>
.modal-wrapper {
  max-width: 860px;
}

.modal-title {
  font-size: 20px;
}

.searchbox {
  display: flex;
  flex-direction: row;
}

.searchbox input {
  height: 39px;
  flex: 1;
  border-radius: 4px 0 0 4px;
}

.searchbox .btn-default {
  text-align: center;
  border-radius: 0 4px 4px 0;
}

.modal-button {
  right: 0 !important;
}

.table-responsive {
  max-height: 265px;
  margin-bottom: 70px;
  overflow-y: scroll;
}

.green-text {
  color: #558c1d;
  font-weight: 800;
}

.action-span {
  display: block;
  height: 32px;
  min-width: 113px;
  padding: 5px 0;
}

.check {
  margin-right: 5px;
}

.btn-done {
  background-color: #27c24c;
  transition: all 0.4s ease-in-out;
  min-width: 93.05px;
  margin-right: 0;
}

.btn-done:hover {
  background-color: #1aa33b;
  border-color: transparent;
}

.alert-success {
  transition: all 0.4s ease-in-out;
}

 .not-found-alert {
   margin-bottom: 50px;
 }
</style>



// WEBPACK FOOTER //
// MergePartialUser.vue?299aeda0